var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinWalletIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17891_6931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5072 24H66V63H8V26.4748C8 25.1067 9.12557 24 10.5072 24Z",
    fill: "#C5E2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9372 32.343C47.1066 33.5167 51.438 31.0948 52.6117 26.9255C53.7854 22.7561 51.3635 18.4247 47.1942 17.251C43.0248 16.0773 38.6934 18.4992 37.5197 22.6685C36.3416 26.8379 38.7679 31.1693 42.9372 32.343Z",
    fill: "#FDC812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 26.6057C45.8583 26.3605 45.8233 26.1284 45.7007 25.9138C45.578 25.6992 45.3196 25.4583 44.9386 25.213C44.4131 24.8846 44.0583 24.5342 43.8788 24.1795C43.6992 23.8247 43.6642 23.4393 43.7868 23.0145C43.905 22.5897 44.1415 22.2525 44.4831 22.0466C44.8248 21.8408 45.2233 21.7707 45.6831 21.8452L45.9284 20.9692L46.5284 21.14L46.2832 22.016C46.7211 22.2087 47.0233 22.4889 47.181 22.8787C47.3386 23.2685 47.3474 23.7327 47.1985 24.2714L46.454 24.0612C46.5591 23.6889 46.5547 23.3561 46.4321 23.0846C46.3094 22.813 46.0948 22.6291 45.797 22.5459C45.4948 22.4627 45.2145 22.4627 44.9824 22.5809C44.7678 22.6992 44.6102 22.905 44.5313 23.1897C44.4569 23.4612 44.4831 23.7021 44.6233 23.9079C44.7591 24.1269 45.0087 24.3503 45.3897 24.5955C45.7707 24.8408 46.0423 25.086 46.2306 25.305C46.4233 25.524 46.5372 25.7649 46.5853 26.0014C46.6335 26.2379 46.6291 26.5006 46.5459 26.7809C46.4189 27.232 46.1737 27.5517 45.8233 27.7444C45.4729 27.9371 45.0481 27.9984 44.5357 27.9108L44.3211 28.6685L43.7211 28.4977L43.9357 27.74C43.454 27.5473 43.0948 27.2671 42.9109 26.8817C42.7226 26.4962 42.6831 26.0408 42.8321 25.5152L43.5766 25.7254C43.4715 26.0977 43.4977 26.4087 43.6379 26.6583C43.778 26.9079 44.0364 27.0919 44.3912 27.1882C44.7459 27.2889 45.0437 27.2758 45.2977 27.1663C45.5518 27.0568 45.7094 26.851 45.7926 26.5707V26.6145L45.7883 26.6057Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0701 15.2934C33.7402 15.3678 36.7752 12.451 36.8497 8.78096C36.9198 5.11089 34.003 2.07585 30.3329 2.00139C26.6628 1.92694 23.6278 4.84373 23.5533 8.51381C23.4789 12.1839 26.3957 15.2189 30.0658 15.2934H30.0701Z",
    fill: "#FDC812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1825 9.97651C31.1825 9.76191 31.1081 9.57797 30.9635 9.42906C30.819 9.28016 30.5562 9.13563 30.1883 9.01738C29.6847 8.85972 29.3212 8.6495 29.0978 8.39548C28.8745 8.14147 28.765 7.8349 28.7694 7.45826C28.7781 7.08599 28.8964 6.75753 29.1329 6.51227C29.3694 6.26702 29.6803 6.12687 30.0745 6.08745L30.0876 5.31665L30.6175 5.32541L30.6044 6.09621C31.0073 6.16191 31.3139 6.32395 31.5241 6.613C31.7387 6.90205 31.8438 7.27432 31.8351 7.75169L31.1781 7.73855C31.1869 7.41008 31.1081 7.13855 30.9504 6.94147C30.7927 6.74439 30.5781 6.63928 30.311 6.6349C30.0482 6.63052 29.8161 6.69183 29.6497 6.83636C29.4964 6.98089 29.4132 7.18235 29.4088 7.43198C29.4044 7.66848 29.4789 7.86556 29.6365 8.00132C29.7942 8.15023 30.0438 8.28162 30.4117 8.39986C30.7752 8.52249 31.0511 8.66264 31.257 8.80278C31.4628 8.94293 31.6073 9.11373 31.6949 9.29768C31.7825 9.48162 31.8351 9.69622 31.8307 9.94585C31.8219 10.34 31.6905 10.6553 31.4453 10.8875C31.2 11.1196 30.8628 11.2597 30.4248 11.2991L30.4117 11.9692L29.8818 11.9605L29.8949 11.2904C29.457 11.2378 29.1066 11.0802 28.8701 10.8042C28.6336 10.5283 28.5022 10.1648 28.511 9.7006L29.1679 9.71373C29.1635 10.0422 29.2467 10.2918 29.4175 10.467C29.5883 10.6422 29.838 10.7342 30.1489 10.7429C30.4599 10.7473 30.7008 10.6729 30.8891 10.5327C31.0774 10.3882 31.1606 10.1867 31.165 9.93709L31.1737 9.97213L31.1825 9.97651Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 26.0032H8V66.0032H62V26.0032Z",
    fill: "#7EC0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1672 38.0032H66V48.0032H49.1672C46.3156 48.0032 44 45.7635 44 43.0053C44 40.2471 46.3156 38.0074 49.1672 38.0074V38.0032Z",
    fill: "#C5E2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 45C50.1046 45 51 44.1046 51 43C51 41.8954 50.1046 41 49 41C47.8954 41 47 41.8954 47 43C47 44.1046 47.8954 45 49 45Z",
    fill: "#1C5170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 26.0032C8 27.6635 9.14764 29.0032 10.5601 29.0032H66V26.0032H8Z",
    fill: "#C5E2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17891_6931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.965 51.7695H3.43731C2.94449 51.7695 2.54498 52.1726 2.54498 52.6699V54.273C2.54498 54.7702 2.94449 55.1733 3.43731 55.1733H17.965C18.4578 55.1733 18.8573 54.7702 18.8573 54.273V52.6699C18.8573 52.1726 18.4578 51.7695 17.965 51.7695Z",
    fill: "#FDC812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48896 52.8352H4.03369V54.0571H4.48896V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10059 52.8352H5.64532V54.0571H6.10059V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70771 52.8352H7.25244V54.0571H7.70771V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31934 52.8352H8.86407V54.0571H9.31934V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9265 52.8352H10.4712V54.0571H10.9265V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5382 52.8352H12.0829V54.0571H12.5382V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1498 52.8352H13.6945V54.0571H14.1498V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7614 52.8352H15.3062V54.0571H15.7614V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3685 52.8352H16.9133V54.0571H17.3685V52.8352Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.42 55.3799H0.892329C0.399509 55.3799 0 55.783 0 56.2802V57.8833C0 58.3806 0.399509 58.7836 0.892329 58.7836H15.42C15.9128 58.7836 16.3123 58.3806 16.3123 57.8833V56.2802C16.3123 55.783 15.9128 55.3799 15.42 55.3799Z",
    fill: "#FDC812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94398 56.4685H1.48871V57.5663H1.94398V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55561 56.4685H3.10034V57.5663H3.55561V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16273 56.4685H4.70746V57.5663H5.16273V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77436 56.4685H6.31909V57.5663H6.77436V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38606 56.4685H7.93079V57.5663H8.38606V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99317 56.4685H9.5379V57.5663H9.99317V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6048 56.4685H11.1495V57.5663H11.6048V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2164 56.4685H12.7612V57.5663H13.2164V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8236 56.4685H14.3683V57.5663H14.8236V56.4685Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4794 58.9858H3.95172C3.4589 58.9858 3.05939 59.3889 3.05939 59.8862V61.4893C3.05939 61.9865 3.4589 62.3896 3.95172 62.3896H18.4794C18.9722 62.3896 19.3717 61.9865 19.3717 61.4893V59.8862C19.3717 59.3889 18.9722 58.9858 18.4794 58.9858Z",
    fill: "#FDC812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13996 60.2537H4.68469V61.2642H5.13996V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74708 60.2537H6.29181V61.2642H6.74708V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35871 60.2537H7.90344V61.2642H8.35871V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97035 60.2537H9.51508V61.2642H9.97035V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5775 60.2537H11.1222V61.2642H11.5775V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1892 60.2537H12.7339V61.2642H13.1892V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 60.2537H14.3455V61.2642H14.8008V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4079 60.2537H15.9526V61.2642H16.4079V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0195 60.2537H17.5643V61.2642H18.0195V60.2537Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8677 62.5962H2.34008C1.84726 62.5962 1.44775 62.9993 1.44775 63.4965V65.0996C1.44775 65.5969 1.84726 66 2.34008 66H16.8677C17.3606 66 17.7601 65.5969 17.7601 65.0996V63.4965C17.7601 62.9993 17.3606 62.5962 16.8677 62.5962Z",
    fill: "#FDC812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39631 63.8962H2.94104V64.9298H3.39631V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00343 63.8962H4.54816V64.9298H5.00343V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61506 63.8962H6.15979V64.9298H6.61506V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22669 63.8962H7.77142V64.9298H8.22669V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83381 63.8962H9.37854V64.9298H9.83381V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4455 63.8962H10.9902V64.9298H11.4455V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0571 63.8962H12.6019V64.9298H13.0571V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6643 63.8962H14.209V64.9298H14.6643V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2759 63.8962H15.8206V64.9298H16.2759V63.8962Z",
    fill: "#A35E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2253 51.2228C14.3137 52.3849 18.5568 49.9872 19.7132 45.8622C20.865 41.7373 18.4885 37.4561 14.4002 36.2894C10.3118 35.1318 6.06418 37.5296 4.91234 41.65C3.76051 45.7749 6.13702 50.0561 10.2253 51.2228Z",
    fill: "#FDC812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0207 45.5452C13.089 45.3017 13.0571 45.0767 12.9342 44.8608C12.8158 44.6495 12.5609 44.4106 12.1876 44.1671C11.6686 43.841 11.3271 43.4965 11.145 43.1428C10.9674 42.7891 10.9356 42.4124 11.0539 41.9898C11.1723 41.5718 11.4 41.2365 11.7369 41.0298C12.0738 40.8231 12.4607 40.7542 12.9114 40.8277L13.1527 39.9641L13.74 40.1295L13.4987 40.9931C13.9267 41.186 14.2226 41.4616 14.3774 41.8474C14.5322 42.2333 14.5413 42.6926 14.3911 43.2255L13.6626 43.0188C13.7674 42.6513 13.7628 42.3206 13.6444 42.0541C13.5261 41.7877 13.3166 41.604 13.0207 41.5213C12.7248 41.4386 12.4471 41.4432 12.224 41.5535C12.01 41.6729 11.8598 41.875 11.7778 42.1552C11.705 42.4216 11.7323 42.6651 11.8689 42.8672C12.0009 43.0831 12.2468 43.3036 12.6201 43.547C12.9934 43.7905 13.2575 44.0293 13.4487 44.2498C13.6353 44.4657 13.7491 44.7046 13.7947 44.9388C13.8402 45.1731 13.8356 45.4303 13.7583 45.7106C13.6353 46.1561 13.394 46.4731 13.048 46.6614C12.702 46.8497 12.2877 46.9094 11.7869 46.8222L11.5775 47.5709L10.9902 47.4055L11.1996 46.6568C10.7262 46.4685 10.3756 46.1883 10.1935 45.807C10.0114 45.4258 9.97041 44.9756 10.1161 44.4519L10.8445 44.6586C10.7398 45.0261 10.7671 45.3385 10.9037 45.5819C11.0448 45.8254 11.2952 46.0091 11.6412 46.1056C11.9873 46.2021 12.2832 46.1929 12.5336 46.0826C12.784 45.977 12.9388 45.7703 13.0162 45.4947V45.536L13.0207 45.5452Z",
    fill: "#A35E05"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17891_6931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17891_6931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 30,
    fill: "white",
    transform: "translate(0 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinWalletIllustration);
export default __webpack_public_path__ + "static/media/coin-wallet-illustration.d2d35fd7f26f4fca342d12390698ce36.svg";
export { ForwardRef as ReactComponent };